<div class='artikel'>
  <div *ngIf="agendaItem">
    <h2 [innerHTML]="agendaItem.title"></h2>
    <p [innerHTML]="agendaItem.content|nl2pbr|sanitizeHtml"></p>
    <div *ngIf='isLoggedIn'> <a routerLink="/beheer/article/{{agendaItem.id}}">Aanpassen</a></div>
  </div>
</div>
